import { RecurrenceEditor } from "./RecurrenceEditor";

const DEFAULT_FIELD_MAP = {
	repeat_text: "repeat_text",
	repeat_this_event: "repeat_this_event",
	repeat_till: "repeat_till",
	rrule_group: "rrule_group",
	rrule: "rrule",
	start: "starts_on",
};

export class RecurrenceButton {
	wrapper: HTMLElement
	frm: any
	button: HTMLButtonElement
	buttonText: HTMLSpanElement
	field_map: { repeat_text: string; repeat_this_event: string; repeat_till: string; rrule_group: string; rrule: string; start: string; };
	editor?: RecurrenceEditor

	constructor(wrapper: HTMLElement, frm: any) {
		this.wrapper = wrapper;
		this.frm = frm;

		this.buttonText = document.createElement("span");

		this.button = document.createElement("button");
		this.button.classList.add("btn", "btn-default");
		this.button.innerHTML = frappe.utils.icon("calendar-sync", "sm");
		this.button.append(" ", this.buttonText);
		this.buttonText.textContent = __("Loading...");
		this.button.addEventListener("click", this.click.bind(this));

		this.wrapper.innerHTML = this.template;
		this.wrapper.querySelector("slot[name=button]")?.replaceWith(this.button);
		this.wrapper.querySelector("slot[name=label]")?.replaceWith(__("Recurrence"));

		this.field_map = { ...DEFAULT_FIELD_MAP };

		const fm = frappe.views?.calendar?.[frm.doctype]?.field_map;
		if (fm?.start) {
			this.field_map.start = fm.start;
		}
		if (fm?.rrule) {
			this.field_map.rrule = fm.rrule;
		}

		this.refresh();
	}

	async getEditor() {
		if (!this.editor) {
			const editor = new RecurrenceEditor();
			await editor.load();
			this.editor = editor;
		}

		let rrule = this.frm.doc.rrule;
		let starts_on = this.frm.doc.starts_on;

		if (!rrule && this.frm.doc.rrule_group) {
			const res = await frappe.db.get_value("Recurrence Group", this.frm.doc.rrule_group, "rrule");
			rrule = res.message.rrule;
		}

		this.editor.set_values({ rrule, starts_on });
		return this.editor;
	}

	async refresh() {
		const editor = await this.getEditor();
		this.buttonText.textContent = editor.get_repeat_text();
	}

	async click() {
		const editor = await this.getEditor();
		editor.show((values) => {
			this.frm.set_value(this.field_map.repeat_this_event, values.repeat_this_event);
			this.frm.set_value(this.field_map.repeat_till, values.repeat_till);
			this.frm.set_value(this.field_map.rrule, values.rrule);
			this.buttonText.textContent = values.repeat_text;
		});
	}

	get template() {
		return `
			<div class="form-group horizontal">
				<div class="clearfix">
					<label class="control-label">
						<slot name="label"></slot>
					</label>
				</div>
				<div class="control-input-wrapper">
					<slot name="button"></slot>
				</div>
			</div>
		`
	}
}
